import { render, staticRenderFns } from "./MonthlyUnitChart.vue?vue&type=template&id=47dabaa8&scoped=true"
import script from "./MonthlyUnitChart.vue?vue&type=script&lang=js"
export * from "./MonthlyUnitChart.vue?vue&type=script&lang=js"
import style0 from "./MonthlyUnitChart.vue?vue&type=style&index=0&id=47dabaa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dabaa8",
  null
  
)

export default component.exports